import axios from "axios"

export const ReportApi = {
    async Type(data){
        const response = await axios.get(`/api/report/list/type/${data}`)
        return response
    },
    async Assign(data){
        const response = await axios.post(`/api/report/reportuser/assign`,data)
        return response
    },
    async RemoveAssign(data){
        const response = await axios.post(`/api/report/reportuser/removeassign/${data}`)
        return response
    },
    async AssignList(){
        const response = await axios.get('/api/report/reportuser/listassigneuser')
        return response
    },
    async VadeTarhiXGunGecmisFaturalar(day){
        const response = await axios.get('/api/report/get/vadetarihixgungecmisfaturalar/'+day)
        return response
    },
    async ReportOfResponsibleUserApprovement(data){
        const response = await axios.post(`/api/report/responsibleuserapprovementprocess`,data)
        return response
    },
    async ExportReportOfResponsibleUserApprovement(data){
        const response = await axios.post(`api/report/responsibleuserapprovementprocess/exportexcel`,data)
        return response
    },
    async AutoSendInvoiceData(data){
        const response = await axios.post(`api/report/get/list/autosentpaymentlink`,data)
        return response
    }
}